module.exports = __webpack_public_path__ + "static/fun-icon3-6607b10c280a391010db4197d1170290.png";